import { Box, Typography } from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";
// Use direct URL path like logo (PNG imports return objects in Parcel)
const favoritesScreenshot = "/favorites-screenshot.png";

export const FavoritesEmptyState: React.FC<{}> = () => {
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Box
        sx={{
          mb: 2,
          border: "1px solid #ccc",
          borderRadius: 2,
          p: 1,
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        <img
          src={favoritesScreenshot}
          alt={t("widgets.favoritesButton.emptyState.imageAlt")}
          style={{ height: 100 }}
        />
      </Box>
      <Typography textAlign="center" variant="body1" maxWidth={500}>
        {t("widgets.favoritesButton.emptyState.message")}
      </Typography>
    </Box>
  );
};
